////////////////////////////////////////////////////////////////////////////////
//
// Device API module
//
////////////////////////////////////////////////////////////////////////////////

import ApiService from "@/services/api.service";

////////////////////////////////////////////////////////////////////////////////

const device = {

    // -- the endpoint
    endpoint: 'device',

    /**
     * Get all accounts
     * @returns {Promise<AxiosResponse<any>>}
     */
    all: (limit,offset) => ApiService.getT(device.endpoint,{ params: { limit, offset } }),
    all_all: (limit,offset) => ApiService.get(device.endpoint,{ params: { limit, offset } }),


    /**
     * Add a device with data
     * @param data
     * @returns {Promise<AxiosResponse<any>>}
     */
    add: (data) => ApiService.postT(device.endpoint, data),

    /**
     * Delete account with name
     * @param name
     * @returns {Promise<AxiosResponse<any>>}
     */
    del: (name) => ApiService.deleteT(`${device.endpoint}/${name}`),

      


    /**
     * Save Site with data
     * @param name dataview resource name
     * @param data { "description": "", "name": "", ... }
     */
    save: (name, data) => {
        const dataCopy = { ...data }
        if (name === dataCopy.name) {
            delete dataCopy.name
        }
        const putData = { operator: { $set: dataCopy } }
        return ApiService.putT(`${device.endpoint}/${name}`, putData)
    },
   AllDeviceAction(payload) {
    // Remove entity parameter, use postT for automatic tenant context
    return ApiService.postT(`mqtt/general/entity`, { payload });
    },
    // In device.js API module
    sendMqttGeneralCommand(deviceName, payload) {
       //console.log(deviceName)
    // Send payload in request body, not as query params
    return ApiService.postT(`mqtt/general/${deviceName}`, { payload });
    },
    sendFget(deviceName, path) {
    return ApiService.postT(`device-fs/${deviceName}/fget`, { path });
},
getFgetResult(requestId) {
    return ApiService.getT(`device-fs/fget-result/${requestId}`);
},
    sendMqttDFU(deviceName) {
    // Send payload in request body, not as query params
    return ApiService.postT(`mqtt/dfu/${deviceName}`);
    },
    MultiDeviceAction(devices, payload) {
    // Send payload in request body, not as query params
    return ApiService.postT(`mqtt/general/devices`, { devices, payload });
    },
    sendMultiDeviceDFU(devices) {
    // Send payload in request body, not as query params
    return ApiService.postT(`mqtt/dfu/devices`,{devices});
    },
    startProvisionProcess(deviceName) {
    // Use postT to automatically include tenant context
    return ApiService.postT(`provision/${deviceName}`);
    },
    getProvisionSSE(deviceName) {
    return ApiService.startEventSource(`provision/${deviceName}/events`);
    },
    cancelProvisionProcess(deviceName){
       //console.log(deviceName)
    return ApiService.postT(`provision/${deviceName}/cancel`);

    },
    deleteAll: () => ApiService.deleteAllT(device.endpoint),
    move: (name, entity) => ApiService.post(`device/${name}/move`, { entity })
}

export default device;